import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import Page from '../containers/page';


import editIcon from '../assets/svg/edit.svg';
import deleteIcon from '../assets/svg/delete.svg';


import {
    Container,
    Row,
    Col,
} from 'reactstrap';

class GalleryPage extends Component {
    constructor(props) {
        super(props);
        this.deletePage = this.deletePage.bind(this);
        this.fetchPages = this.fetchPages.bind(this);


        this.state = {
            items: []
        };
    }

    componentDidMount() {
        this.fetchPages();


    }

    fetchPages() {
        if (!localStorage.token) {
            return;
        }

        fetch('https://api.freedommusic.rs/admin/gallery', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                items: result
            })
        })


    }

    deletePage(id) {
        if (!localStorage.token) {
            return;
        }

        fetch('https://api.freedommusic.rs/admin/gallery/delete/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`

            },
        }).then((res) => this.fetchPages())
    }
    render() {

        return (
            <div className="page-wrap">
                {
                    !localStorage.token ? <Redirect to='/login' /> : null
                }

                <Container fluid className="table">

                    <Row className="page-title">
                        <Col lg="12">
                            <h3>ALBUMI</h3>
                        </Col>
                    </Row>
                    <Row className="table-head">
                        <Col lg="10">
                            <span className="name">NAZIV</span>
                        </Col>
                        <Col lg="2" className="actions">

                            <span className="name">OPCIJE</span>
                        </Col>

                    </Row>
                    {
                        this.state.items && this.state.items.map((item, idx) => {
                            return (
                                <Row className="table-row" key={idx}>
                                    <Col lg="10">
                                        <span className="value">album</span>
                                    </Col>
                                    <Col lg="2" className="actions">
                                        <Link to={`/gallery/${item._id}`}><Isvg src={editIcon} /></Link>
                                        <button onClick={() => this.deletePage(item._id)}><Isvg src={deleteIcon} /></button>

                                    </Col>

                                </Row>

                            )
                        })
                    }


                </Container>



            </div>
        );
    }
}

export default Page(GalleryPage);